import { API_BASE_URL } from "../../config";
import { BaseService } from "./base-service";

export class Catalinav2BaseService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }
}
